import React from 'react';
import { connect } from 'react-redux';
import { userService, auth } from '../../../../services';
import { logout, getLoggedinUser } from '../../../../Redux/Actions/EndUser/AuthActions';
import './AuthenticatedMenu.css';
import { Collapse, Navbar, NavLink } from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AuthenticatedMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
		  };
		this.toggle = this.toggle.bind(this);
		this.logoutClick = this.logoutClick.bind(this);
	}

	componentDidMount() {
		this.props.getLoggedinUser();
	}

	logoutClick(event) {
		logout();
		event.preventDefault();
	}

	toggle() {
	  this.setState({ isOpen: !this.state.isOpen });
	}

	setMenu() {
		var userName = auth.getAuthUserEmail();
		if (userName) {
			userService.getUserProfile(userName).then(({ data }) => {
				var role = data.roles.length ? data.roles[0].toUpperCase() : 'USER';
				if (role.toUpperCase() === 'INTERNAL') role = 'ADMIN';

				this.setState({
					displayName: `${role} - ${data.firstName} ${data.lastName}`,
					memberStatus: data.memberStatus,
					memberSince: `Member Since - ${data.memberSince}`,
					memberNumber: data.memberNumber
				});
			});
		}
	}

	render() {
		const user = this.props.user && this.props.user.firstName && this.props.user.lastName ?
			`- ${this.props.user.firstName} ${this.props.user.lastName}` : '- Guest User';

        return (
            <div className="authenticated-menu">
				<button type="button" className="navbar-toggler" onClick={this.toggle}>
					<span className="navbar-toggler-icon"></span>
				</button>
				<Collapse isOpen={this.state.isOpen}>
					<div className="d-flex flex-row-reverseXX dropdown align-items-center">

						{this.props.loading || !this.props.user ? null :
							<div className="d-flex flex-column sm-padding">
								<div className="display-name">
									<NavLink tag={RouterNavLink} to="/my-account">
										<FontAwesomeIcon className="mr-1" icon="user" />
										{`${this.props.user && this.props.user.roleName} ${user}`}
									</NavLink>
								</div>
								{auth.isInRole('INTERNAL') ? "" :
									(
										this.props.user && this.props.user.memberStatus ?
										< div className="member-status">
											<span>
												Member Status:{' '}
												<strong className="text-success">
													{this.props.user && this.props.user.memberStatus}
												</strong>
											</span>
										</div>
										:
										''
									)
                                }
                                {auth.isInRole('INTERNAL') ? "" :
									(
										this.props.user && this.props.user.memberSince ?
										<div className="member-status">
											<span>
												Member Since:{' '}
												<strong className="text-success">
													{this.props.user && this.props.user.memberSince}
												</strong>
											</span>
										</div>
										: ''
									)
                                }
							</div>
						}
						<div className="d-flex sm-padding align-items-center logout-button p-1">
							<button className="logout-btn btn btnPrimary" onClick={this.logoutClick}>
								Logout
							</button>
						</div>

					</div>
				</Collapse>

			</div>
		);
	}

	// render() {
	// 	var menu = this.props.loading ? null : this.getView();
	// 	return menu;
	// }
}

function mapStateToProps(state) {
	const { user, email, loading } = state.authentication;
	return {
		user,
		email,
		loading
	};
}

export default connect(mapStateToProps, { getLoggedinUser })(AuthenticatedMenu);
